<template>
  <div>
    <div>
      <slot name="primary" />
    </div>

    <div v-if="visible">
      <slot name="secondary" />
    </div>
  </div>
</template>

<script>
export default {
  name: "DynamicVisibility",
  data() {
    return {
      visible: true,
    };
  },
  methods: {
    toggle(visible) {
      this.visible = visible;
    },
  },
};
</script>
